// extracted by mini-css-extract-plugin
module.exports = {"minmaxInput":"style_minmaxInput__1QU27","minmaxInput__second":"style_minmaxInput__second__681IT"};